<header>
    <h1 class="center" style="margin-bottom: 15px;">{{data?.title}}</h1>
    <div class="center">
        <div class="article-header-image">
            @if (imageSrc) {
                <img [ngSrc]="imageSrc" [attr.srcset]="imageSrcset" [sizes]="imageSizes" [alt]="data.image.alt" [width]="imageWidth" [height]="imageHeight" priority>
            } @else if (data?.image?.src) {
                <img [ngSrc]="data.image.src" [alt]="data.image.alt" [width]="imageWidth" [height]="imageHeight" priority>
            }
        </div>

        <p class="updated-date">Last Updated: {{ data.modifiedDate | date }}</p>
    </div>
</header>
<article-share [url]="data?.url ?? ''"></article-share>